export default {
    root: {
        gap: '0.5rem',
        transitionDuration: '{transition.duration}'
    }
};
